export default __webpack_public_path__ + "static/media/60t.449eb839.jpg";